import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Db,RESTConnector,RESTSerializer } from "../node_modules/@slyte/data/index.js";

class ZcatComponentsDb extends Db{
    _() {
        _;
    }
}

ZcatComponentsDb.Connector = RESTConnector;ZcatComponentsDb.Serializer = RESTSerializer;

ZcatComponentsDb.register({
    hash: "db_zcat-ui-component-docs_app_0"
});

let Schema = ZcatComponentsDb.Schema;
export {ZcatComponentsDb,Schema};
